
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
	ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
	SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { ExecutionPointerService } from 'tnx-admin-service/workflowcore/executionpointer/services';

@Component({
	selector: 'executionpointer-form',
	templateUrl: './executionpointer-form.component.html',
	styleUrls: ['./executionpointer-form.component.scss'],
	providers: [ComponentContextService],
})
export class ExecutionPointerFormComponent extends DataFormBase implements OnInit {

	constructor(
		protected _injector: Injector,
		private _executionPointerService: ExecutionPointerService
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setting.baseService = this._executionPointerService;
		this.setting.schema = <FormSchemaBase[]>[
			new TextControlSchema({
				field: 'persistenceId',
				label: ''
			}),
			new SwitchControlSchema({
				field: 'active',
				label: ''
			}),
			new TextControlSchema({
				field: 'retryCount',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'endTime',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventData',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventKey',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventName',
				label: ''
			}),
			new SwitchControlSchema({
				field: 'eventPublished',
				label: ''
			}),
			new TextControlSchema({
				field: 'persistenceData',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'sleepUntil',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'startTime',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepId',
				label: ''
			}),
			new TextControlSchema({
				field: 'stepName',
				label: ''
			}),
			new TextControlSchema({
				field: 'workflowId',
				label: ''
			}),
			new TextControlSchema({
				field: 'children',
				label: ''
			}),
			new TextControlSchema({
				field: 'contextItem',
				label: ''
			}),
			new TextControlSchema({
				field: 'predecessorId',
				label: ''
			}),
			new TextControlSchema({
				field: 'outcome',
				label: ''
			}),
			new TextControlSchema({
				field: 'scope',
				label: ''
			}),
			new TextControlSchema({
				field: 'status',
				label: ''
			}),
			new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			}),
			new TextControlSchema({
				field: 'code',
				label: ''
			})
		];
	}

	async onFormInitialized(formEvent: EventData) {
		// tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
	}

	async onFormEvent(evt) {
		// các event trong form
		console.log(evt);
	}

	async modifyDetailData(data) {
		// xử lý dữ liệu lấy từ get detail về
	}

	async onAfterGetDetail() {
		// xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
	}

	onBeforeSave() {
		// trước khi lưu
	}
}

